export function validateEmail(value) {
    let error;
    if (!value) {
      error = "Complete este campo";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Correo electrónico no válido";
    }
    return error;
  }